import { Bot } from "lucide-react";
import { AWSBedrockLogo } from "@/components/integrations/logos";

interface AgentProviderLogoProps {
  provider?: string | null;
  className?: string;
}

export function AgentProviderLogo({ provider, className = "h-7 w-7" }: AgentProviderLogoProps) {
  const normalized = provider?.toLowerCase() ?? "";

  if (normalized.includes("aws") || normalized.includes("bedrock") || normalized.includes("sagemaker")) {
    return <AWSBedrockLogo className={className} />;
  }

  if (normalized.includes("openai")) {
    return <img src="/openai-provider-logo.svg" className={`${className} object-contain`} alt="OpenAI" />;
  }

  if (normalized.includes("anthropic") || normalized.includes("claude")) {
    return <img src="/claude-provider-logo.svg" className={`${className} object-contain`} alt="Claude" />;
  }

  if (normalized.includes("google") || normalized.includes("gemini") || normalized.includes("vertex")) {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-label="Google Gemini" role="img">
        <path d="M12 2c.72 5.37 4.63 9.28 10 10-5.37.72-9.28 4.63-10 10-.72-5.37-4.63-9.28-10-10 5.37-.72 9.28-4.63 10-10Z" fill="url(#gemini-gradient)" />
        <defs><linearGradient id="gemini-gradient" x1="4" y1="4" x2="20" y2="20"><stop stopColor="#4285F4"/><stop offset=".48" stopColor="#9B72CB"/><stop offset="1" stopColor="#D96570"/></linearGradient></defs>
      </svg>
    );
  }

  return <Bot className={`${className} text-[#00B0E4]`} aria-label="AI provider" />;
}
